<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
    <div id="home_main">
        <div class="home_main">
            <div class="home-left">
                <div class="home_carousel">
                    <el-carousel height="200px" :indicator-position="carouselList.length === 1 ? 'none' : 'inside'">
                        <el-carousel-item v-for="(item, index) in carouselList" :key="index">
                            <img :src="item.img" width="100%" height="100%" style="object-fit: cover;" />
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="home_main1 t-m-t-20">
                    <img class="cursor_1 t-m-r-17" src="@/assets/image/home/xs.png" width="300" height="164"
                        @click="routerPathJump(1)" alt="">
                    <img class="cursor_1 t-m-r-16" src="@/assets/image/home/dj.png" width="256" height="164"
                        @click="routerPathJump(2)" alt="">
                    <img class="cursor_1  t-m-r-18" src="@/assets/image/home/zjb.png" width="256" height="164" @click="toZjb"
                        alt="">
                    <img v-if="flag === 'true'" class="cursor_1" src="@/assets/image/home/rmtc.png" width="256" height="164"
                        @click="toRmtc" alt="">
                    <img v-else class="cursor_1" src="@/assets/image/home/cs.png" width="256" height="164"
                        @click="routerPathJump(3)" alt="">

                </div>
                <div class="home_main2">
                    <div class="home_main2_1"><img class="t-m-r-8" src="@/assets/image/home/label.png" width="26.5"
                            height="17.4" />热门场景</div>
                    <div class="home_main2_2">
                        <div class="home_main2_3 cursor_1 bgImg" :class="item.color" v-for="(item, i) in labelList"
                            :key="i" @click="toCreate(i)">
                            <img :src="item.iconV2" alt="" v-lazyload="item.iconV2">
                            <div class="home_main2_4 cursor_1">
                                <div class="home_main2_5"> {{ item.name }}</div>
                                <div class="home_main2_6"> {{ item.description }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="home_main2" v-for="(items, index) in AIList" :key="index">
                    <div class="home_main2_1"><img class="t-m-r-8" src="@/assets/image/home/label.png" width="26.5"
                            height="17.4" />{{ items.categoryName }}</div>
                    <div class="home_main2_2">
                        <div class="home_main2_3 cursor_1 bgImg" :class="item.color"
                            v-for="(item, i) in items.questionTemplates" :key="i" @click="toAICreate(index, i)">
                            <img :src="item.iconV2" alt="" v-lazyload="item.iconV2">
                            <div class="home_main2_4 cursor_1">
                                <div class="home_main2_5"> {{ item.name }}</div>
                                <div class="home_main2_6"> {{ item.description }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="home-right">
                <!-- 官方通知 -->
                <div class="home_right__item">
                    <div class="home_right__item_title flex-row t-m-l-27 t-m-r-27 t-p-t-20 t-p-b-10">
                        <p> <img class="t-m-r-8" src="@/assets/image/home/label.png" width="26.5" height="17.4" />{{
                            titleList[0].name }}
                        </p>
                        <p class="home_right__item_more cursor_1" @click.stop="moreMessage(titleList[0].type)">更多<i
                                class="el-icon-arrow-right t-m-l-4"></i></p>
                    </div>
                    <div class="home_right__item_name cursor_1" v-for="(item, index) in gfList" :key="index"
                        @click.stop="messageDetail(item.id)" v-show="item.title">
                        <p style="color: #242424;">
                            <span class="u-line-1">{{ item.title }}</span>
                        </p>
                        <p style="color: #828282;font-size: 14px;margin: 0.3rem 0;">{{ item.uploadedTime }}</p>
                    </div>
                </div>
                <!-- 导师直播 -->
                <div class="home_right__item">
                    <div class="home_right__item_title flex-row t-m-l-27 t-m-r-27 t-p-t-20 t-p-b-10">
                        <p> <img class="t-m-r-8" src="@/assets/image/home/label.png" width="26.5" height="17.4" />{{
                            titleList[1].name }}</p>
                        <p class="home_right__item_more cursor_1" @click.stop="moreMessage(titleList[1].type)">更多<i
                                class="el-icon-arrow-right t-m-l-4"></i></p>
                    </div>
                    <div class="home_right__item_name cursor_1" v-for="(item, index) in zbList" :key="index"
                        @click.stop="messageDetail(item.id)" v-show="item.title">
                        <p style="color: #242424;">
                            <span class="u-line-1">{{ item.title }}</span>
                        </p>
                        <p style="color: #828282;font-size: 14px;margin: 0.3rem 0;">{{ item.uploadedTime }}</p>
                    </div>
                </div>
                <!-- vip课程教程 -->
                <div class="home_right__item">
                    <div class="home_right__item_title flex-row t-m-l-27 t-m-r-27 t-p-t-20 t-p-b-10">
                        <p> <img class="t-m-r-8" src="@/assets/image/home/label.png" width="26.5" height="17.4" />{{
                            titleList[2].name }}</p>
                        <p class="home_right__item_more cursor_1" @click.stop="moreMessage(titleList[2].type)">更多<i
                                class="el-icon-arrow-right t-m-l-4"></i></p>
                    </div>
                    <div class="home_right__item_name cursor_1" v-for="(item, index) in vipList" :key="index"
                        @click.stop="messageDetail(item.id)" v-show="item.title">
                        <p style="color: #242424;">
                            <span class="u-line-1">{{ item.title }}</span>
                        </p>
                        <p style="color: #828282;font-size: 14px;margin: 0.3rem 0;">{{ item.uploadedTime }}</p>
                    </div>
                </div>
                <!-- 视频教程 -->
                <div class="home_right__item">
                    <div class="home_right__item_title flex-row t-m-l-27 t-m-r-27 t-p-t-20 t-p-b-10">
                        <p> <img class="t-m-r-8" src="@/assets/image/home/label.png" width="26.5" height="17.4" />{{
                            titleList[3].name }}</p>
                        <p class="home_right__item_more cursor_1" @click.stop="moreMessage(titleList[3].type)">更多<i
                                class="el-icon-arrow-right t-m-l-4"></i></p>
                    </div>
                    <div class="home_right__item_name cursor_1" v-for="(item, index) in jcList" :key="index"
                        @click.stop="messageDetail(item.id)" v-show="item.title">
                        <p style="color: #242424;">
                            <span class="u-line-1">{{ item.title }}</span>
                        </p>
                        <p style="color: #828282;font-size: 14px;margin: 0.3rem 0;">{{ item.uploadedTime }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="t-p-20 flex-row-center foot" v-if="!hideBeian">
            <a href="https://beian.miit.gov.cn" target="_blank" class="filing"
                style="color: #000;">鄂ICP备2021008188号-10</a> <span class="t-m-l-10">Copyright © 2025-2028
                qmzuojia.com 全民作家版权所有</span>
        </div>
        <el-backtop target=".home_main" :bottom="10" :right="15"></el-backtop>
    </div>
</template>

<script>
import api from '@/api/api';
import { EventBus } from '@/utils/eventBus'
export default {
    data() {
        return {
            labelList: [],
            AIList: [],
            colors: ['blue', 'green', 'purple', 'pink', 'orange'],
            titleList: [{
                name: '官方通知',
                type: 'category2'
            }, {
                name: '导师直播',
                type: 'category3'
            },
            {
                name: 'VIP导师课堂',
                type: 'ketang'
            },
            {
                name: '视频教程',
                type: 'categery4'
            }],
            gfList: [],
            zbList: [],
            vipList: [],
            jcList: [],
            carouselList: [],
            flag: 'false'
        }
    },
    created() {
        this.getUserLoginState(false)
        this.noVipWXCode()
        this.rmflag()
        this.getHome()
        this.AITools()
        this.getHomeMessage()
    },
    computed: {
        hideBeian() {
            const domain = window.location.hostname;
            if (domain.includes('qmzj.xueerd.com')) {
                return true
            }
            return false
        }
    },
    methods: {
        //消息公告
        moreMessage(type) {
            this.$router.push({ path: '/message', query: { type } })
        },
        //公告详情
        messageDetail(id) {
            if (this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            this.$router.push({ path: '/message', query: { id, home: 1 } })
        },
        noVipWXCode() {
            api.homeSlide().then(res => {
                if (res.code === 200) {
                    this.carouselList = res.data
                }
            })
        },
        //首页转剧本和热门题材的切换开关
        rmflag() {
            api.rmtcFlag().then(res => {
                if (res.code === 200) {
                    this.flag = res.data
                }
            })
        },
        async getHomeMessage() {
            //官方公告
            let gf = await api.getDynamicsList(this.titleList[0].type, { pageNum: 1 })
            //导师直播
            let zb = await api.getDynamicsList(this.titleList[1].type, { pageNum: 1 })
            //vip课堂教程
            let vip = await api.getDynamicsList(this.titleList[2].type, { pageNum: 1 })
            //视频教程
            let jc = await api.getDynamicsList(this.titleList[3].type, { pageNum: 1 })

            if (gf.code === 200 && gf.data) {
                this.gfList = (gf.data.filter((_, i) => i < 3))
            }
            if (zb.code === 200 && zb.data) {
                this.zbList = (zb.data.filter((_, i) => i < 2))
            }
            if (jc.code === 200 && jc.data) {
                this.jcList = (jc.data.filter((_, i) => i < 2))
            }
            if (vip.code === 200 && vip.data) {
                this.vipList = (vip.data.filter((_, i) => i < 3))
            }

        },
        getHome() {
            api.getHome().then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.labelList = res.data.map((item, i) => {
                        const colorIndex = i % this.colors.length;
                        return {
                            ...item,
                            color: item.bgColor ? item.bgColor : this.colors[colorIndex],
                        };
                    });
                    sessionStorage.setItem('labelList', JSON.stringify(this.labelList));
                }
            })
        },
        AITools() {
            api.aiHostTools().then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.AIList = res.data.filter((items) => {
                        items.questionTemplates = items.questionTemplates.map((item, i) => {
                            const colorIndex = i % this.colors.length;
                            return {
                                ...item,
                                color: item.bgColor ? item.bgColor : this.colors[colorIndex],
                            };
                        })
                        return items
                    });
                }
            })
        },

        toZjb() {
            // this.$message.success('敬请期待')
            this.$router.push({ path: '/novelTurnScript_list' });
        },
        toRmtc() {
            if (this.showLoginPage()) return
            this.$router.push({ path: '/hottc' });
        },
        //ai热门写作工具
        toAICreate(index, i) {
            // if (!this.loginState) {
            //     EventBus.$emit('openLogin')
            //     return
            // }
            sessionStorage.setItem('aiList', JSON.stringify(this.AIList?.[index].questionTemplates ?? []));
            sessionStorage.setItem('aiIndex', i);
            this.$router.push({ path: '/novelgeneratorTemplate' });
        },
        //ai其他工具
        toCreate(i) {
            // if (!this.loginState) {
            //     EventBus.$emit('openLogin')
            //     return
            // }
            this.$router.push({ path: '/novelgenerator' });
            sessionStorage.setItem('labelIndex', i);
        },
        //小说转剧本
        novelTurnScript() {
            //通配符移除
            Object.keys(sessionStorage).forEach(key => {
                if (key.includes('_csText')) {
                    sessionStorage.removeItem(key);
                }
                if (key.includes('_fxText')) {
                    sessionStorage.removeItem(key);
                }
            });
            sessionStorage.removeItem('apartStatus')
            this.$router.push({ path: '/novelTurnScript' })
        }
    }
};
</script>

<style scoped lang="scss">
p {
    margin: 0;
    padding: 0;
}

#home_main {
    flex: 1;
    height: 100%;
    padding: 16px 23px 0 40px;
    display: flex;
    flex-direction: column;
}

.home_main {
    flex: 1;
    // border: 1px solid red;
    display: flex;
    overflow: auto;
}

.home-left {
    flex: 1;
    // border: 1px solid green;
    overflow: auto;
    @include scrollbar(none);

    .home_carousel {
        border-radius: 16px;
        overflow: hidden;
    }

    .home_main1 {
        display: flex;

        img {
            display: block;
            object-fit: fill;
        }
    }


    .home_main2_1 {
        font-weight: bold;
        font-size: 20px;
        color: #111111;
        margin-top: 27px;
        margin-bottom: 21px;
    }

    .home_main2_2 {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 20px;
        margin-bottom: 20px;
        /* 抵消最后一行的影响 */
        box-sizing: border-box;
        padding: 20px;
        background-color: #FFF;
        border-radius: 10px;
    }

    .home_main2_3 {
        // background-color: #f0f7ff;
        padding: 20px;
        border-radius: 8px;


        &.orange {
            background: url('@/assets/image/home/orange.png') no-repeat;
        }

        &.pink {
            background: url('@/assets/image/home/pink.png') no-repeat;
        }

        &.purple {
            background: url('@/assets/image/home/purple.png') no-repeat;
        }

        &.green {
            background: url('@/assets/image/home/green.png') no-repeat;
        }

        &.blue {
            background: url('@/assets/image/home/blue.png') no-repeat;
        }

        &.bgImg {
            background-size: cover !important;
            background-position: center !important;
        }

        img {
            border-radius: 8px;
        }
    }

    .home_main2_3:nth-child(4n) {
        margin-right: 0;
    }

    .home_main2_3 img {
        width: 58px;
        height: 58px;
        margin-right: 20px;
    }

    .home_main2_4 {}

    .home_main2_5 {
        width: 100%;
        font-size: 18px;
        color: #333333;
        font-weight: 600;
        margin-bottom: 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
    }

    .home_main2_6 {
        width: 100%;
        font-size: 15px;
        color: #666666;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}



.filing:hover {
    color: var(--tech-primary) !important;
}

.home-right {
    height: 100%;
    flex-shrink: 0;
    width: 480px;
    padding-left: 15px;
    overflow: auto;
    @include no_scrollbar;

    .home_right__item {
        background: #FFFFFF;
        border-radius: 16px;
        margin-bottom: 27px;
        padding-bottom: 10px;
    }

    .home_right__item:last-child {
        margin-bottom: 0px;
    }

    .home_right__item_title {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 20px;
        color: #000000;
        line-height: 20px;
        justify-content: space-between;
    }

    .home_right__item_more {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
    }

    .home_right__item_name {
        font-family: Microsoft YaHei;
        font-size: 16px;
        margin: 0 33px;
        padding: 0.7rem 0;
        border-bottom: 1px dashed #DDDDDD;
        // &:hover{
        //     background-color: ;
        // }
    }

    .home_right__item_name:last-child {
        border-bottom: 0;
    }

}

.foot {
    flex-shrink: 0;
    height: 40px;
}
</style>